import "./OldBelowFold.css";
import homecollage from "../../assets/images/homecollage.jpg";
import homecollagewide from "../../assets/images/homecollagewide.jpg";

function OldBelowFold() {
  return (
    <div className="old-hero-section1-below-fold">
      <div className="old-hero-1-full-width-border-alt" id="how-it-works">
        <div className="old-hero-1-below-fold-how-it-works-container">
          <div className="old-hero-1-below-fold-how-it-works-headline">
            How It Works
          </div>
          <div className="old-hero-1-below-fold-how-it-works-points-grid">
            <div className="old-hero-1-below-fold-how-it-works-individual-point">
              <div className="old-hero-1-below-fold-how-it-works-individual-point-headline">
                <div className="old-hero-1-how-it-works-bullet-number-and-text">
                  <div className="old-hero-1-how-it-works-bullet-number">1</div>
                  <div className="old-hero-1-how-it-works-bullet-text">
                    Enter Your Address
                  </div>
                </div>
              </div>
              <div className="old-hero-1-below-fold-how-it-works-individual-point-text">
                Enter your address in the form to get started. We'll ask you a
                few questions about your house. If you're ready to move
                forward, we'll schedule an appointment to see your home in
                person.
              </div>
            </div>
            <div className="old-hero-1-below-fold-how-it-works-individual-point">
              <div className="old-hero-1-below-fold-how-it-works-individual-point-headline">
                <div className="old-hero-1-how-it-works-bullet-number-and-text">
                  <div className="old-hero-1-how-it-works-bullet-number">2</div>
                  <div className="old-hero-1-how-it-works-bullet-text">
                    Get Your Offer
                  </div>
                </div>
              </div>
              <div className="old-hero-1-below-fold-how-it-works-individual-point-text">
                We'll make you a cash offer for your house "as is" within 24
                hours. If you accept the offer, we'll set up a closing to
                complete the transaction. It's that easy!
              </div>
            </div>
            <div className="old-hero-1-below-fold-how-it-works-individual-point">
              <div className="old-hero-1-below-fold-how-it-works-individual-point-headline">
                <div className="old-hero-1-how-it-works-bullet-number-and-text">
                  <div className="old-hero-1-how-it-works-bullet-number">3</div>
                  <div className="old-hero-1-how-it-works-bullet-text">
                    Close Quickly
                  </div>
                </div>
              </div>
              <div className="old-hero-1-below-fold-how-it-works-individual-point-text">
                Tired of waiting months to sell your house? We can close in as
                little as 7 days from the date you accept our offer. We can
                even help you with moving and relocation services!
              </div>
            </div>
          </div>
          <div className="old-hero-1-below-fold-summary-text">
            At HomeSurge.AI we want to take the stress out of selling with AI-powered accuracy.
          </div>
        </div>
      </div>

      <div className="old-hero-1-full-width-border" id="about">
        <div className="old-hero-1-below-fold-about-us-headline">About Us</div>

        <div className="old-hero-1-below-fold-about-us-parent-container">
          <div className="old-hero-1-below-fold-about-us-left-right-container">
            <img
              className="old-hero-1-below-fold-about-us-left-image"
              src={homecollage}
              alt="HomeSurge.AI About Us"
              loading="lazy"
            />
            <img
              className="old-hero-1-below-fold-about-us-left-image-mobile"
              src={homecollagewide}
              alt="HomeSurge.AI About Us"
              loading="lazy"
            />

            <div className="old-hero-1-below-fold-about-us-right">
              <div className="old-hero-1-below-fold-about-us-right-text">
                At HomeSurge.AI, we've revolutionized the home selling process with
                AI-powered property valuations and instant cash offers. No more realtor meetings, repairs,
                endless costs, or complicated closings. We pride ourselves in
                providing accurate market valuations and competitive cash offers to anyone looking to get out of
                their house as quickly or as easily as possible. No matter
                what condition your house is in or what your timeline is, we
                can help! Give us a call or fill out the form below to receive
                your AI-powered cash offer now.<br></br>
                <br></br>HomeSurge.AI is a technology-driven real estate company that
                started in Atlanta, GA, and has expanded nationwide. Our
                absolute priority is giving our clients accurate AI-powered valuations and an excellent home
                selling experience, no matter the timeline or condition of the
                home. Reach out to us, we'd love to help in any way we can!{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="old-hero-1-full-width-border" id="benefits">
        <div className="old-hero-1-below-fold-benefits-container">
          <div className="old-hero-1-below-fold-benefits-headline">
            Benefits of Working With HomeSurge.AI
          </div>
          <div className="old-hero-1-below-fold-benefits-points-grid">
            <div className="old-hero-1-below-fold-benefits-individual-point">
              <div className="old-hero-1-below-fold-benefits-individual-point-headline">
                <div className="old-hero-1-benefits-bullet-number-and-text">
                  <div className="old-hero-1-benefits-bullet-number">1</div>
                  <div className="old-hero-1-benefits-bullet-text">
                    No Repairs, Closing Costs, or Time Consuming Listings
                  </div>
                </div>
              </div>
              <div className="old-hero-1-below-fold-benefits-individual-point-text">
                We'll make you a cash offer for your house "as is" within 24
                hours. No contingencies, repairs, or listing prep necessary.
                You can receive cash for your home in as little as 14 days.
              </div>
            </div>
            <div className="old-hero-1-below-fold-benefits-individual-point">
              <div className="old-hero-1-below-fold-how-it-works-individual-point-headline">
                <div className="old-hero-1-benefits-bullet-number-and-text">
                  <div className="old-hero-1-benefits-bullet-number">2</div>
                  <div className="old-hero-1-benefits-bullet-text">
                    Quick Transactions
                  </div>
                </div>
              </div>
              <div className="old-hero-1-below-fold-benefits-individual-point-text">
                No more waiting for buyers to get approved for financing. We
                have the cash to buy your house without any need for loan
                approval or any other time consuming processes.
              </div>
            </div>
            <div className="old-hero-1-below-fold-benefits-individual-point">
              <div className="old-hero-1-below-fold-how-it-works-individual-point-headline">
                <div className="old-hero-1-benefits-bullet-number-and-text">
                  <div className="old-hero-1-benefits-bullet-number">3</div>
                  <div className="old-hero-1-benefits-bullet-text">
                    Packing, Moving, and Relocation Assistance
                  </div>
                </div>
              </div>
              <div className="old-hero-1-below-fold-benefits-individual-point-text">
                Not only will we buy your house, but we can also help you with
                the moving process. We can help you pack, move, and even help
                you find a new place, whether you plan on buying or renting.
              </div>
            </div>
          </div>
          <div className="old-hero-1-below-fold-summary-text">
            Choosing HomeSurge.AI means getting accurate AI-powered valuations and selling your house fast
            for a great price, without the hassle.
          </div>
        </div>
      </div>

      <div className="old-hero-1-below-fold-contact-container" id="contact">
        <div className="old-hero-1-below-fold-contact-headline">
          <div className="old-hero-1-below-fold-contact-headline-text">
            Contact Us
          </div>
          <div className="old-hero-1-below-fold-contact-headline-subtext">
            We're here to help. Call us at (404) 671-4628 or fill out the form
            below.
          </div>
        </div>
      </div>
    </div>
  );
}

export default OldBelowFold;